import authConfig from './auth-config.json';

export const environment = {
  production: false,
  enableFooterRegionInfo: true,
  redirect_uri: "https://dev.passlink.bayer.com/callback",
  baseUrl: "https://dev.passlink.bayer.com",
  apiUrl: "https://dev.passlink.bayer.com/api",
  apiKey: "4_hyAnSzIllnGi-3bUFjkHMw",
  clientId: "OCcae0htXSFc--VGWAvbiRXq",
  issuer_url: "https://fidm.eu1.gigya.com/oidc/op/v1.0",
  ...authConfig,
  firebaseConfig: {
    apiKey: "AIzaSyCB7UvrBmnr3XRAKycWLlPD31bR8fwFP3o",
    authDomain: "pbeat03002010-prod-4dd2-silver.firebaseapp.com",
    projectId: "pbeat03002010-prod-4dd2-silver",
    storageBucket: "pbeat03002010-prod-4dd2-silver.firebasestorage.app",
    messagingSenderId: "402284785450",
    appId: "1:402284785450:web:07811748462ec300203853",
    measurementId: "G-0W3L2DWBKV"

  },
  gigyaProviderId: "oidc.gigyadev",
  gigyaProxyUrl: "/proxy",
  gigyaCallbackUrl: "/callback",
  useExplicitCookies: false,
  JFROG_URL: 'https://bayer-radiology-edge-qa.bayer.com/artifactory',
  LOG_CONFIG: { level: "DEBUG", console: true, remote: false },
  errorReporting: { projectId: "pbeat03002010-prod-4dd2-silver", apiKey: "" },
};
